import Keycloak from 'keycloak-js';
import constants from '../constants';

export class KeycloakManager {
  public static instance: KeycloakManager;

  private static KEYCLOAK: Keycloak.KeycloakInstance;

  private constructor() {
    KeycloakManager.KEYCLOAK = Keycloak(constants.KEYCLOAK);
  }

  public static getInstance(): KeycloakManager {
    if (!KeycloakManager.instance) {
      KeycloakManager.instance = new KeycloakManager();
    }
    return KeycloakManager.instance;
  }

  public async login() {
    const response = await KeycloakManager.KEYCLOAK.init({
      onLoad: 'login-required',
      checkLoginIframe: true
    }).then((authenticated: boolean) => ({ authenticated }));
    const { token, refreshToken, tokenParsed } = KeycloakManager.KEYCLOAK;
    const roles = (tokenParsed as any)?.roles ?? [];
    const roleFlags = this.getRoleFlags(roles);
    const primaryRole = this.determinePrimaryRole(roles);
    return {
      token,
      refreshToken,
      tokenParsed,
      ...roleFlags,
      role: primaryRole,
      ...response
    };
  }

  public async logout() {
    const urlOrigin = window.location.origin;
    await KeycloakManager.KEYCLOAK.logout({
      redirectUri: urlOrigin
    });
  }

  public async refreshToken(timestamp: number) {
    await KeycloakManager.KEYCLOAK.updateToken(timestamp);
    return this.getToken();
  }

  public getToken(): any {
    const { token, refreshToken, realmAccess } = KeycloakManager.KEYCLOAK;
    const { tokenParsed }: any = KeycloakManager.KEYCLOAK;
    const { roles } = (tokenParsed as any) || { roles: [] };
    const roleFlags = this.getRoleFlags(roles);
    const primaryRole = this.determinePrimaryRole(roles);
    localStorage.setItem('role', primaryRole);
    return {
      token,
      refreshToken,
      roles: realmAccess?.roles || [],
      ...roleFlags,
      userId: tokenParsed?.preferred_username || '',
      userName: tokenParsed?.given_name || '',
      role: primaryRole
    };
  }

  private getRoleFlags(roles: string[]): { [key: string]: boolean } {
    const roleFlags: { [key: string]: boolean } = {};
    constants.ROLES.forEach((role: string) => {
      roleFlags[`is${this.capitalize(role)}`] = this.validateRol(role, roles);
    });
    return roleFlags;
  }

  determinePrimaryRole(roles: string[]): string {
    const prioritizedRoles = ['student', 'simulator', 'visor'];
    return prioritizedRoles.find((role) => this.validateRol(role, roles)) ?? '';
  }

  validateRol(rol: string, array: string[] = []) {
    return array.includes(rol) || false;
  }

  private capitalize(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}
